<template>
  <v-card ripple @click="openBucket">
    <v-card-title primary-title>
      <div style='width:100%;'>
        <v-icon class="bucket_icon">storage</v-icon>
        <p class="bucket_name">{{ name }}</p>
      </div>
    </v-card-title>
  </v-card>
</template>
<script>
export default {
  name: "Bucket",
  props: {
    id: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    project_id: {
      type: Number,
      required: true
    }
  },
  methods: {
    openBucket(){
      this.$router.push(this.project_id + "/bucket/" + this.id);
    }
  }
}
</script>
<style scoped>
.v-card{
  cursor: pointer;
  text-align: center;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding-top:20px;
}
.bucket_icon{
  font-size: 40px;
}
.bucket_name{
  font-size: 15px;
}
</style>
